import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    getExtrato(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('empresa-financeiro-distribuicao/extrato', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    getExtratoResumo(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('empresa-financeiro-distribuicao/extrato-resumo', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },
  },
}
